// Единая безопасная обёртка над нативным JS-интерфейсом (window.Android).
// Любой вызов натива оборачивается в try/catch и проверку наличия метода,
// чтобы устаревший/обновлённый Android-клиент не ронял веб белым экраном.
// Имена и сигнатуры экспортируемых функций НЕ менялись — контракт с нативом сохранён.

const hasAndroid = () => typeof window.Android !== "undefined" && window.Android !== null;

// Вызывает метод натива, если он есть. Иначе (или при ошибке) возвращает fallback.
// fallback может быть значением или функцией.
const callNative = (method, args, fallback) => {
    try {
        if (hasAndroid() && typeof window.Android[method] === "function") {
            return window.Android[method].apply(window.Android, args || []);
        }
    } catch (e) {
        console.error("native bridge error: " + method, e);
    }
    return typeof fallback === "function" ? fallback() : fallback;
};

export function showAndroidToast(toast) {
    callNative("showToast", [toast]);
}

export function isAppInstalled(bundle) {
    return callNative("isAppInstalled", [bundle], false);
}

export function openUrl(url) {
    return callNative("openUrl", [url], () => {
        window.open(url, '_blank');
    });
}

export function openApp(bundle) {
    return callNative("openApp", [bundle], false);
}

export function registrationFailed(desc) {
    return callNative("registrationFailed", [desc], false);
}

export function finish() {
    return callNative("finish", [], false);
}

export function copyId(id, text) {
    return callNative("copyId", [id, text], () => {
        var textField = document.createElement('textarea');
        textField.innerText = id;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();
    });
}

export function showReviewDialog() {
    callNative("showReviewDialog");
}

export function checkPickPhoto() {
    callNative("checkPickPhoto");
}

export function openAppWithParams(bundle, google_user_id, order_id) {
    return callNative("openAppWithParams", [bundle, google_user_id, order_id], false);
}
